// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bgl_a bhj_bi"};